module.exports = __webpack_public_path__ + "static/media/8-min.f8c02a56.png";